import {
   MedicalServicePerformableByPractitionerSimple,
   ReceptionServiceForPractitionerSimple,
   ServicesTemplate,
} from '@dreryk/egabinet-private-medical-service-frontend-api';

import { TextEditorValue } from '@dreryk/react-text-editor';

import { PrescriptionVisitTemplatesLoaderData } from './PrescriptionVisitTemplates.loader';
import { PrescriptionVisitTemplatesFormBean } from './PrescriptionVisitTemplatesForm.types';

const resolveReceptionService = (
   receptionServices: ReceptionServiceForPractitionerSimple[],
   servicesTemplate: ServicesTemplate | undefined
): ReceptionServiceForPractitionerSimple | null =>
   receptionServices.find(
      (service) => service.receptionServiceId.asNumber() === servicesTemplate?.receptionServiceId?.asNumber()
   ) ?? null;

const resolveMedicalService = (
   medicalServices: MedicalServicePerformableByPractitionerSimple[],
   servicesTemplate: ServicesTemplate | undefined
): MedicalServicePerformableByPractitionerSimple | null =>
   medicalServices.find((service) => service.medicalServiceId === servicesTemplate?.medicalServiceId) ?? null;

export const formInitializer = (
   data: PrescriptionVisitTemplatesLoaderData
): (() => PrescriptionVisitTemplatesFormBean) => () => {
   const { visitTemplate, servicesTemplate, receptionServices, medicalServices } = data;

   return {
      interview: visitTemplate?.interview ? TextEditorValue.fromFormatted(visitTemplate.interview) : null,
      physicalExamination: visitTemplate?.physicalExamination
         ? TextEditorValue.fromFormatted(visitTemplate.physicalExamination)
         : null,
      recommendations: visitTemplate?.recommendations
         ? TextEditorValue.fromFormatted(visitTemplate.recommendations)
         : null,
      diagnosis: visitTemplate?.diagnosis
         ? { code: visitTemplate.diagnosis.getCode().asString(), name: visitTemplate.diagnosis.getName().asString() }
         : null,
      procedure: visitTemplate?.procedure
         ? { code: visitTemplate.procedure.getCode().asString(), name: visitTemplate.procedure.getName().asString() }
         : null,
      receptionService: resolveReceptionService(receptionServices, servicesTemplate),
      medicalService: resolveMedicalService(medicalServices, servicesTemplate),
   };
};
